import { useEffect } from "react";
import GoshtaHeader from "@/goshta/GoshtaHeader";
import GoshtaHero from "@/goshta/GoshtaHero";
import GoshtaStatement from "@/goshta/GoshtaStatement";
import GoshtaMarquee from "@/goshta/GoshtaMarquee";
import GoshtaCapabilities from "@/goshta/GoshtaCapabilities";
import GoshtaWritingRoom from "@/goshta/GoshtaWritingRoom";
import GoshtaCollaborate from "@/goshta/GoshtaCollaborate";
import GoshtaHowWeWork from "@/goshta/GoshtaHowWeWork";
import GoshtaContact from "@/goshta/GoshtaContact";
import GoshtaFooter from "@/goshta/GoshtaFooter";
import WhatsAppButton from "@/components/WhatsAppButton";
import { initLenis } from "@/lib/lenis";

const GOSHTA_WA =
  "https://wa.me/918850845977?text=Hi%20Goshta%2C%20I%27d%20like%20to%20discuss%20a%20production%20brief%20or%20a%20story%20idea.";

export default function GoshtaLanding() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="bg-[#050505] text-neutral-100 antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <GoshtaHeader />
      <main>
        <GoshtaHero />
        <GoshtaMarquee />
        <GoshtaStatement />
        <GoshtaCapabilities />
        <GoshtaWritingRoom />
        <GoshtaCollaborate />
        <GoshtaHowWeWork />
        <GoshtaContact />
      </main>
      <GoshtaFooter />
      <WhatsAppButton link={GOSHTA_WA} brand="Goshta" />
    </div>
  );
}
